import type { SubscriptionModal } from '@entities/subscription'
import type { SubscriptionsStore } from './interfaces'

export const actions = {
  setLoading (this: SubscriptionsStore, payload: SubscriptionsStore['loading']): void {
    this.loading = payload
  },
  /** Called with `true` when a write starts and `false` when it settles. */
  trackProcessing (this: SubscriptionsStore, isStarted: boolean): void {
    this.processing = Math.max(0, this.processing + (isStarted ? 1 : -1))
  },
  setSubscriptions (this: SubscriptionsStore, payload: SubscriptionsStore['subscriptions']): void {
    this.subscriptions = payload
  },
  setMeta (this: SubscriptionsStore, payload: SubscriptionsStore['meta']): void {
    this.meta = payload
  },
  setAgents (this: SubscriptionsStore, payload: SubscriptionsStore['agents']): void {
    this.agents = payload
  },
  setDiscounts (this: SubscriptionsStore, payload: SubscriptionsStore['discounts']): void {
    this.discounts = payload
  },
  setFilterSearch (this: SubscriptionsStore, payload: SubscriptionsStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterStatuses (this: SubscriptionsStore, payload: SubscriptionsStore['filterStatuses']): void {
    this.filterStatuses = payload
  },
  setFilterFrom (this: SubscriptionsStore, payload: SubscriptionsStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: SubscriptionsStore, payload: SubscriptionsStore['filterTo']): void {
    this.filterTo = payload
  },
  setFilterCustomerId (this: SubscriptionsStore, payload: SubscriptionsStore['filterCustomerId']): void {
    this.filterCustomerId = payload
  },
  setCurrentPage (this: SubscriptionsStore, payload: SubscriptionsStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: SubscriptionsStore, payload: SubscriptionsStore['perPage']): void {
    this.perPage = payload
  },
  toggleExpanded (this: SubscriptionsStore, subscriptionId: number): void {
    this.expandedId = this.expandedId === subscriptionId ? null : subscriptionId
  },
  openModal (this: SubscriptionsStore, modal: SubscriptionModal, subscriptionId: number): void {
    this.activeModal = modal
    this.modalSubscriptionId = subscriptionId
  },
  closeModal (this: SubscriptionsStore): void {
    this.activeModal = null
    this.modalSubscriptionId = null
  },
  setRetryTarget (this: SubscriptionsStore, payload: SubscriptionsStore['retryTarget']): void {
    this.retryTarget = payload
  },
  /** Leaving the page must not reopen a modal or an unfolded row on the next visit. */
  resetPageState (this: SubscriptionsStore): void {
    this.activeModal = null
    this.modalSubscriptionId = null
    this.retryTarget = null
    this.expandedId = null
  },
  resetFilters (this: SubscriptionsStore): void {
    this.filterSearch = null
    this.filterStatuses = []
    this.filterFrom = null
    this.filterTo = null
    this.filterCustomerId = null
    this.currentPage = 1
  },
}
